import React from 'react';
import PropTypes from 'prop-types';

import CompareTableHeadItem from '@/braun/components/molecules/CompareTableHeadItem';

const CompareTableHead = ({ titles }) => {
  const tableHeadItems = titles.map(title => (
    <CompareTableHeadItem
      key={`compare-table-head-item-${title}`}
      title={title}
    />
  ));

  return (
    <thead className='bra-comparsionTable__head'>
      <tr className='bra-comparsionTable__row'>{tableHeadItems}</tr>
    </thead>
  );
};

CompareTableHead.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CompareTableHead;
